const DEFAULT_TRACKING_DATA = {
    page_category: 'Marketing Landing Page',
    page_subcategory: '',
    platform_version: 'new',
    site_section: 'Marketing pages',
    url_without_domain: '',
    url_without_domain_global: '',
    vendor_domain_name: '',
};

export const defaultTrackingData = DEFAULT_TRACKING_DATA;
